export class RuntimeInstance {
  constructor(
    public readonly typeName: string,
    public readonly fields: Record<string, unknown>
  ) {}
}
